module.exports = __webpack_public_path__ + "static/media/agenda.ba2d7eee.svg";